import { Navigate, Outlet } from "react-router-dom";
import { useProfile } from "@/hooks/useProfile";
import { FullPageLoader } from "@/components/FullPageLoader";
import { ProfileErrorState } from "@/components/ProfileErrorState";
import { ROUTES } from "@/constants/routes";

export function ProfileGate({ mode }) {
  const { profile, loading, error } = useProfile();
  if (loading) return <FullPageLoader label="Loading your profile" />;
  if (error || !profile) return <ProfileErrorState message={error} />;
  const onboarded = Boolean(profile.onboarding_completed);
  if (mode === "dashboard" && !onboarded) return <Navigate to={ROUTES.onboarding} replace />;
  if (mode === "onboarding" && onboarded) return <Navigate to={ROUTES.dashboard} replace />;
  return <Outlet />;
}
